<div class="container-fluid p-4 font-name">
  <div class="page-header">
    <i class="bi bi-arrow-left-short back-icon" (click)="goBack()"></i>

    <div class="header-content">
      <h2>My Sessions</h2>
      <p class="subtitle">
        Track and manage your mentorship sessions in one place
      </p>
    </div>
  </div>

  <div class="policy-box">
    <i class="bi bi-info-circle me-2"></i>
    <span>Refund and Cancellation Policy</span><br />
    <div class="policy-content">
      <span> Important</span>: If a session is cancelled through Google Meet
      link (by either student or mentor), you must come to this platform to
      process your refund. The refund window is available 24 hours prior to the
      scheduled session time after the mentor has accepted it. Check the
      "Cancelled" tab to process any pending refunds.
      <br />
      <span>Important</span>: Session cancellation option is not available
      within 12 hours of the session start time.
    </div>
  </div>

  <div class="container-fluid mb-4 mt-4">
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-content">
          <div class="stat-text">
            <p class="label">Upcoming Sessions</p>
            <h3 class="value">{{ upcomingSessionCount }}</h3>
          </div>
          <div class="avatar">
            <mat-icon>event</mat-icon>
          </div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-content">
          <div class="stat-text">
            <p class="label">Completed Sessions</p>
            <h3 class="value">{{ completed_count }}</h3>
          </div>
          <div class="avatar">
            <mat-icon>currency_rupee</mat-icon>
          </div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-content">
          <div class="stat-text">
            <p class="label">Total Spent</p>
            <h3 class="value">{{ totalPaymentAmount }}</h3>
          </div>
          <div class="avatar">
            <mat-icon>credit_card</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="tabs-container mb-4">
    <ng-container *hasPermission="PermissionForStudents.MENTOR_SESSIONS">
      <button
        class="tab"
        [class.active]="selectedTab === SessionTypeEnum.Upcoming"
        (click)="selectTab(SessionTypeEnum.Upcoming)"
      >
        <i class="bi bi-bell"></i>
        Upcoming Sessions ({{ upcomingSessionCount || "0" }})
      </button>
      <button
        class="tab"
        [class.active]="selectedTab === SessionTypeEnum.Past"
        (click)="selectTab(SessionTypeEnum.Past)"
      >
        <i class="bi bi-clock-history"></i>
        History ({{ historyCount || "0" }})
      </button>
    </ng-container>
    <ng-container *hasPermission="PermissionForStudents.MENTOR_CANCELLATION">
      <button
        class="tab"
        [class.active]="selectedTab === SessionTypeEnum.Cancelled"
        (click)="selectTab(SessionTypeEnum.Cancelled)"
      >
        <i class="bi bi-x-circle"></i>
        Cancelled ({{ cancelCount || "0" }})
      </button>
    </ng-container>
    <ng-container *hasPermission="PermissionForStudents.PAYMENTS_VIEW">
      <button
        class="tab"
        [class.active]="selectedTab === SessionTypeEnum.Payments"
        (click)="selectTab(SessionTypeEnum.Payments)"
      >
        <i class="bi bi-wallet2"></i>
        Payments ({{ paymentCount || "0" }})
      </button>
    </ng-container>
  </div>

  <div *ngIf="selectedTab === SessionTypeEnum.Upcoming" class="tab-content">
    <ng-container *ngIf="isSessionLoading; else noSessionPage">
      <div class="app-spinner">
        <mat-spinner diameter="60"></mat-spinner>
      </div>
    </ng-container>
    <ng-template #noSessionPage>
      <ng-container *ngIf="mentorSession.length > 0; else noSessionFound">
        <div class="session-list">
          <mat-card class="session-card" *ngFor="let mentor of mentorSession">
            <div class="session-header p-2">
              <div class="profile">
                <div class="avatar-container">
                  <div class="avatar">
                    {{ getUserNameInitials(mentor.mentor_name) }}
                  </div>
                  <span
                    class="status-dot"
                    [ngClass]="{
                      'dot-accepted':
                        mentor.status === sessionMeetingStatus.Accepted,
                      'dot-waiting':
                        mentor.status ===
                        sessionMeetingStatus.Awaiting_Acceptance,
                      'dot-pending':
                        mentor.status === sessionMeetingStatus.Pending_Payment,
                      'dot-cancel':
                        mentor.status === sessionMeetingStatus.Cancelled,
                    }"
                  >
                  </span>
                </div>
                <div class="info">
                  <h4>{{ mentor.mentor_name }}</h4>
                  <p>{{ mentor.session_type }}</p>
                </div>
              </div>
              <app-status-badge [status]="mentor.status"></app-status-badge>
            </div>

            <div class="session-meta">
              <div class="meta-item">
                <mat-icon>event</mat-icon>
                <div class="meta-text">
                  <span class="label">Date</span>
                  <span class="value">{{
                    mentor.appointment_datetime_utc | date: "MMM d, y"
                  }}</span>
                </div>
              </div>

              <div class="meta-item">
                <mat-icon>schedule</mat-icon>
                <div class="meta-text">
                  <span class="label">Time</span>
                  <span class="value">
                    {{ formatTime(mentor.appointment_datetime_utc) }} -
                    {{ formatTime(mentor.end_datetime_utc) }}
                  </span>
                </div>
              </div>
              <div class="meta-item">
                <mat-icon>timer</mat-icon>
                <div class="meta-text">
                  <span class="label">Duration</span>
                  <span class="value">{{ mentor.duration_minutes }} min</span>
                </div>
              </div>
              <div class="meta-item">
                <mat-icon>currency_rupee</mat-icon>
                <div class="meta-text">
                  <span class="label">Amount</span>
                  <span class="value">
                    {{ mentor.amount === 0 ? "Free" : mentor.amount }}
                  </span>
                </div>
              </div>
            </div>
            <ng-container
              *ngIf="mentor.status === sessionMeetingStatus.Pending_Payment"
            >
              <div class="payment-box mt-2 mb-2">
                <i class="bi bi-exclamation-triangle-fill"></i>
                Your time slot is reserved for 10 minutes. Complete payment to
                confirm your booking else the slot will be released.
              </div>
            </ng-container>

            <div class="action-btns">
              <ng-container
                *ngIf="
                  mentor.status === sessionMeetingStatus.Awaiting_Acceptance
                "
              >
                <button
                  *hasPermission="PermissionForStudents.MENTOR_VIEW"
                  class="cancel-session"
                  matTooltip="This option will be enabled once the mentor accepts the session."
                >
                  <i class="bi bi-camera-video"></i> Join Session
                </button>
                <span
                  [matTooltip]="
                    !isCancellation(mentor)
                      ? 'Cancellation is allowed only up to 12 hours before session start.'
                      : ''
                  "
                  matTooltipPosition="above"
                >
                  <button
                    *hasPermission="PermissionForStudents.MENTOR_CANCELLATION"
                    class="btn-cancel"
                    [disabled]="!isCancellation(mentor)"
                    (click)="openSessionCancelDialogBox(mentor)"
                  >
                    <i class="bi bi-x-circle"></i> Cancel Session
                  </button>
                </span>
              </ng-container>

              <ng-container
                *ngIf="mentor.status === sessionMeetingStatus.Accepted"
              >
                <span
                  [matTooltip]="
                    !isJoinEnabled(mentor)
                      ? 'Join Session button will be enabled 5 minutes before the session start time
				and will be disabled once the session ends.'
                      : ''
                  "
                  matTooltipPosition="above"
                >
                  <button
                    [disabled]="!isJoinEnabled(mentor)"
                    class="btn-add"
                    (click)="joinSession(mentor.google_meet_link)"
                  >
                    <i class="bi bi-camera-video"></i> Join Session
                  </button>
                </span>

                <ng-container
                  *hasPermission="PermissionForStudents.MENTOR_CANCELLATION"
                >
                  <button
                    class="btn-cancel"
                    (click)="openSessionCancelDialogBox(mentor)"
                    *ngIf="isCancellation(mentor)"
                  >
                    <i class="bi bi-x-circle"></i>
                    Cancel Session
                  </button>
                </ng-container>
              </ng-container>

              <ng-container
                *ngIf="mentor.status === sessionMeetingStatus.Pending_Payment"
              >
                <button
                  *hasPermission="PermissionForStudents.PAYMENTS_CREATE"
                  class="btn-add"
                  (click)="
                    postRazorPayment(
                      mentor.product_id!,
                      mentor.pricing_id!,
                      mentor.booking_id!,
                      mentor.amount!,
                      mentor.mentor_id
                    )
                  "
                >
                  Complete Payment
                </button>
              </ng-container>

              <ng-container
                *ngIf="mentor.status === sessionMeetingStatus.Completed_Session"
              >
                <span class="completed-text">
                  <i class="bi bi-check-circle-fill"></i> Completed
                </span>
              </ng-container>

              <ng-container
                *ngIf="mentor.status === sessionMeetingStatus.Missed_Session"
              >
                <span class="missed-text">
                  <i class="bi bi-exclamation-circle-fill"></i> Missed
                </span>
              </ng-container>
            </div>
          </mat-card>
        </div>
        <div
          class="text-center mt-3"
          *ngIf="
            mentorSession.length > 0 && !isSessionLoading && pageNo < totalPages
          "
        >
          <button
            class="btn-add"
            (click)="getUpcomingMentorSession(true)"
            [disabled]="isLoadMoreLoading"
          >
            <ng-container *ngIf="isLoadMoreLoading; else btnText">
              <span class="spinner-border spinner-border-sm"></span> Loading...
            </ng-container>
            <ng-template #btnText>Load More</ng-template>
          </button>
        </div>
      </ng-container>
      <ng-template #noSessionFound>
        <p class="text-center mt-5">No Upcoming Session Found</p>
      </ng-template>
    </ng-template>
  </div>

  <div *ngIf="selectedTab === SessionTypeEnum.Past" class="tab-content">
    <ng-container *ngIf="isHistoryLoading; else noHistoryPage">
      <div class="app-spinner">
        <mat-spinner diameter="60"></mat-spinner>
      </div>
    </ng-container>
    <ng-template #noHistoryPage>
      <ng-container *ngIf="mentorHistory.length > 0; else noMentorHistory">
        <div class="session-list">
          <mat-card class="session-card" *ngFor="let mentor of mentorHistory">
            <div class="session-header p-3">
              <div class="profile">
                <div class="avatar">
                  {{ getUserNameInitials(mentor.mentor_name) }}
                </div>
                <div class="info">
                  <h4>{{ mentor.mentor_name }}</h4>
                  <p>{{ mentor.session_type }}</p>
                </div>
              </div>
              <app-status-badge [status]="mentor.status"></app-status-badge>
            </div>
            <div class="session-meta">
              <div class="meta-item">
                <mat-icon>event</mat-icon>
                <div class="meta-text">
                  <span class="label">Date</span>
                  <span class="value">{{
                    mentor.appointment_datetime_utc | date: dateFormat
                  }}</span>
                </div>
              </div>

              <div class="meta-item">
                <mat-icon>schedule</mat-icon>
                <div class="meta-text">
                  <span class="label">Time</span>
                  <span class="value">
                    {{ formatTime(mentor.appointment_datetime_utc) }} -
                    {{ formatTime(mentor.end_datetime_utc) }}
                  </span>
                </div>
              </div>

              <div class="meta-item">
                <mat-icon>timer</mat-icon>
                <div class="meta-text">
                  <span class="label">Duration</span>
                  <span class="value">{{ mentor.duration_minutes }} min </span>
                </div>
              </div>

              <div class="meta-item">
                <mat-icon>currency_rupee</mat-icon>
                <div class="meta-text">
                  <span class="label">Amount</span>
                  <span class="value">{{ mentor.amount }}</span>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
        <div
          class="text-center mt-3"
          *ngIf="
            mentorHistory.length > 0 &&
            !isHistoryLoading &&
            historytPageNo < historyTotalPages
          "
        >
          <button
            class="btn-add"
            (click)="getAllMentorHistory(true)"
            [disabled]="isHistoryLoadMoreLoading"
          >
            <ng-container *ngIf="isHistoryLoadMoreLoading; else btnText">
              <span class="spinner-border spinner-border-sm"></span> Loading...
            </ng-container>
            <ng-template #btnText>Load More</ng-template>
          </button>
        </div>
      </ng-container>
      <ng-template #noMentorHistory>
        <p class="text-center mt-5">No Mentor History Found</p>
      </ng-template>
    </ng-template>
  </div>

  <div *ngIf="selectedTab === SessionTypeEnum.Cancelled" class="tab-content">
    <ng-container *ngIf="isSessionLoading; else noSessionPage">
      <div class="app-spinner">
        <mat-spinner diameter="60"></mat-spinner>
      </div>
    </ng-container>
    <ng-template #noSessionPage>
      <ng-container *ngIf="cancelSession.length > 0; else noSessionFound">
        <div class="session-list">
          <mat-card
            class="session-card"
            *ngFor="let mentor of cancelSession; let i = index"
          >
            <div class="session-header p-2">
              <div class="profile">
                <div class="avatar">
                  {{ getUserNameInitials(mentor.mentor_name) }}
                </div>
                <div class="info">
                  <h4>{{ mentor.mentor_name }}</h4>
                  <p>{{ mentor.session_type }}</p>
                </div>
              </div>

              <ng-container
                *ngIf="
                  mentor.refund_status === sessionMeetingStatus.Refunded ||
                    mentor.refund_status ===
                      sessionMeetingStatus.Refunded_Processing;
                  else normalStatus
                "
              >
                <app-status-badge
                  [status]="mentor.refund_status"
                ></app-status-badge>
              </ng-container>

              <ng-template #normalStatus>
                <app-status-badge [status]="mentor.status"></app-status-badge>
              </ng-template>
            </div>

            <div class="session-meta">
              <div class="meta-item">
                <mat-icon>event</mat-icon>
                <div class="meta-text">
                  <span class="label">Date</span>
                  <span class="value">{{
                    mentor.appointment_datetime_utc | date: dateFormat
                  }}</span>
                </div>
              </div>

              <div class="meta-item">
                <mat-icon>schedule</mat-icon>
                <div class="meta-text">
                  <span class="label">Time</span>
                  <span class="value">
                    {{ formatTime(mentor.appointment_datetime_utc) }} -
                    {{ formatTime(mentor.end_datetime_utc) }}
                  </span>
                </div>
              </div>
              <div class="meta-item">
                <mat-icon>timer</mat-icon>
                <div class="meta-text">
                  <span class="label">Duration</span>
                  <span class="value"> {{ mentor.duration_minutes }} min </span>
                </div>
              </div>
              <div class="meta-item">
                <mat-icon>currency_rupee</mat-icon>
                <div class="meta-text">
                  <span class="label">Amount</span>
                  <span class="value">
                    {{ mentor.amount === 0 ? "Free" : mentor.amount }}
                  </span>
                </div>
              </div>
            </div>

            <div class="policy-box mt-2">
              <i class="bi bi-arrow-repeat me-2"></i>

              <ng-container
                *ngIf="
                  mentor.refund_status === sessionMeetingStatus.Refunded ||
                    mentor.refund_status ===
                      sessionMeetingStatus.Refunded_Processing;
                  else showCancelMessage
                "
              >
                <span>
                  {{
                    mentor.refund_status === sessionMeetingStatus.Refunded
                      ? "Refund Successful"
                      : "Refund
                  Processing"
                  }}</span
                >

                <div class="policy-content">
                  <span>Important</span>:

                  <ng-container
                    *ngIf="
                      mentor.refund_status ===
                      sessionMeetingStatus.Refunded_Processing
                    "
                  >
                    Your refund is currently being processed. You will receive
                    an email once it is completed.
                  </ng-container>

                  <ng-container
                    *ngIf="
                      mentor.refund_status === sessionMeetingStatus.Refunded
                    "
                  >
                    Refund completed successfully.The amount has been refunded
                    to your original payment method. Please check your email for
                    confirmation.
                  </ng-container>
                </div>
              </ng-container>
              <ng-template #showCancelMessage>
                <ng-container
                  *ngIf="mentor.amount === 0; else showNormalMessages"
                >
                  <div class="free-tag">Free Booking</div>
                  <div class="policy-content">
                    <span>Important</span>: This was a free booking. No refund
                    is required.
                  </div>
                </ng-container>

                <ng-template #showNormalMessages>
                  <span
                    *ngIf="
                      mentor.status ===
                        sessionMeetingStatus.Cancelled_By_Mentor;
                      else studentCancelled
                    "
                  >
                    Session Cancelled by Mentor
                  </span>

                  <ng-template #studentCancelled>
                    <span>Session Cancelled by You</span>
                  </ng-template>

                  <div class="policy-content">
                    <span>Important</span>:

                    <ng-container
                      *ngIf="
                        mentor.status ===
                          sessionMeetingStatus.Cancelled_By_Mentor;
                        else studentMsg
                      "
                    >
                      Your mentor has cancelled this session. Please click the
                      button below to process your refund. The credits will be
                      returned to your account immediately.
                    </ng-container>

                    <ng-template #studentMsg>
                      As this cancellation was made within 12 hours of the
                      session start time, no refund will be initiated, in
                      accordance with our cancellation policy.
                    </ng-template>
                  </div>
                </ng-template>
              </ng-template>
            </div>

            <ng-container *hasPermission="PermissionForStudents.MENTOR_REFUND">
              <div class="action-btns">
                <button
                  (click)="postRefundPayment(mentor.booking_id, i)"
                  class="btn-cancel"
                  *ngIf="
                    mentor.status !== sessionMeetingStatus.Cancelled &&
                    (mentor.status === null ||
                      mentor.status ===
                        sessionMeetingStatus.Cancelled_By_Mentor ||
                      mentor.status ===
                        sessionMeetingStatus.Cancelled_By_Student) &&
                    mentor.refund_status !==
                      sessionMeetingStatus.Refunded_Processing &&
                    !(
                      mentor.refund_status === sessionMeetingStatus.Refunded &&
                      (mentor.status ===
                        sessionMeetingStatus.Cancelled_By_Student ||
                        mentor.status ===
                          sessionMeetingStatus.Cancelled_By_Mentor)
                    )
                  "
                >
                  <ng-container
                    *ngIf="refundButtonLoadingIndex === i; else noLoadingRefund"
                  >
                    <span class="spinner-border spinner-border-sm"></span>
                    Processing...
                  </ng-container>

                  <ng-template #noLoadingRefund>
                    <i class="bi bi-arrow-repeat"></i> Process Refund
                  </ng-template>
                </button>
              </div>
            </ng-container>
          </mat-card>
        </div>
        <div
          class="text-center mt-3"
          *ngIf="
            cancelSession.length > 0 &&
            !isSessionLoading &&
            cancelPageNo < cancelTotalPages
          "
        >
          <button
            class="btn-add"
            (click)="getMentorCancelled(true)"
            [disabled]="isCancelLoadMoreLoading"
          >
            <ng-container *ngIf="isCancelLoadMoreLoading; else btnText">
              <span class="spinner-border spinner-border-sm"></span> Loading...
            </ng-container>
            <ng-template #btnText>Load More</ng-template>
          </button>
        </div>
      </ng-container>
      <ng-template #noSessionFound>
        <p class="text-center mt-5">No cancellation found</p>
      </ng-template>
    </ng-template>
  </div>

  <div *ngIf="selectedTab === SessionTypeEnum.Payments" class="tab-content">
    <ng-container *ngIf="isPaymentHistory; else showPaymentHistory">
      <div class="app-spinner">
        <mat-spinner diameter="60"></mat-spinner>
      </div>
    </ng-container>
    <ng-template #showPaymentHistory>
      <ng-container *ngIf="mentorPayment.length > 0; else noPaymentFound">
        <div class="session-list">
          <mat-card class="session-card" *ngFor="let mentor of mentorPayment">
            <div class="session-header">
              <div class="profile">
                <div class="avatar avatar2">
                  <mat-icon>credit_card</mat-icon>
                </div>
                <div class="info">
                  <h4>
                    {{ mentor.session_type || "-" }} with
                    {{ mentor.mentor_name || "-" }}
                  </h4>
                  <span>{{ mentor.payment_id }}</span>
                </div>
              </div>
              <div class="credits-block">
                <div class="credit-top-row">
                  <i class="bi bi-currency-rupee"></i>
                  <span>{{ mentor.amount }}</span>
                </div>
                <span class="coin">{{ mentor.payment_method }}</span>
                <span
                  class="status"
                  [ngClass]="{
                    pending:
                      mentor.status ===
                      MentorSessionPaymentBookingStatus.Pending,
                    'credit-status':
                      mentor.status ===
                      MentorSessionPaymentBookingStatus.Complete,
                    awaiting:
                      mentor.status ===
                      MentorSessionPaymentBookingStatus.Refunded,
                  }"
                >
                  <i
                    class="bi"
                    [ngClass]="{
                      'bi-clock-history':
                        mentor.status ===
                        MentorSessionPaymentBookingStatus.Pending,
                      'bi-check-circle':
                        mentor.status ===
                        MentorSessionPaymentBookingStatus.Complete,
                      'bi-arrow-counterclockwise':
                        mentor.status ===
                        MentorSessionPaymentBookingStatus.Refunded,
                    }"
                  ></i>
                  {{ MentorSessionPaymentStatusLabel[mentor.status] }}
                </span>
              </div>
            </div>
            <div class="session-details">
              <div class="date-time">
                <i class="bi bi-calendar me-1"></i>
                <span class="me-2"
                  >{{ mentor.created_at | date: dateFormat }}
                </span>
              </div>
            </div>
          </mat-card>
        </div>
        <div
          class="text-center mt-3"
          *ngIf="
            mentorPayment.length > 0 &&
            !isPaymentHistory &&
            paymentPageNo < paymentTotalPages
          "
        >
          <button
            class="btn-add"
            (click)="getCompleteHistoryPayment(true)"
            [disabled]="isPaymentLoadMoreLoading"
          >
            <ng-container *ngIf="isPaymentLoadMoreLoading; else btnText">
              <span class="spinner-border spinner-border-sm"></span> Loading...
            </ng-container>
            <ng-template #btnText>Load More</ng-template>
          </button>
        </div>
      </ng-container>
      <ng-template #noPaymentFound>
        <p class="text-center mt-5">No Payment History Found</p>
      </ng-template>
    </ng-template>
  </div>
</div>
